"use client";

import { usePathname } from "next/navigation";
import Link from "next/link";
import { ChevronRight } from "lucide-react";

const Breadcrumb = ({ transparent = false, items = null }) => {
  const pathname = usePathname();
  // URL ko segments mein split karein
  const segments = pathname.split("/").filter((x) => x);

  // Yahan woh list likh dein jinhein click nahi karna
  const disabledLinks = ["/destinations", "/admin", "/booking", "/onboarding", "/attractions"];

  // Agar Home page par hain to breadcrumb mat dikhayein
  if (pathname === "/") return null;

  const renderItems = () => {
    if (items) {
      return (
        <>
          <li>
            <Link
              href={segments[0] === "supplier" ? "/supplier/dashboard" : "/"}
              className={transparent ? "text-white/90 hover:text-white" : ""}
            >
              Home
            </Link>
          </li>
          {items.map((item, index) => {
            const isClickable = item.href && index !== items.length - 1;
            return (
              <li key={index} className="flex items-center gap-0.5 md:gap-1.5">
                <span className={`span-text ${transparent ? "text-white/50" : "text-gray-400"}`}>
                  <ChevronRight size={16} className="link-text" />
                </span>
                {isClickable ? (
                  <Link
                    href={item.href}
                    className={transparent ? "text-white/90 hover:text-white" : ""}
                  >
                    {item.label}
                  </Link>
                ) : (
                  <span
                    className={
                      transparent
                        ? index === items.length - 1
                          ? "text-white/60 span-text"
                          : "text-white/90 span-text"
                        : index === items.length - 1
                          ? "text-gray-400 span-text"
                          : "text-primary span-text"
                    }
                  >
                    {item.label}
                  </span>
                )}
              </li>
            );
          })}
        </>
      );
    }

    return (
      <>
        <li>
          <Link
            href={segments[0] === "supplier" ? "/supplier/dashboard" : "/"}
            className={transparent ? "text-white/90 hover:text-white" : ""}
          >
            Home
          </Link>
        </li>
        {segments.map((segment, index) => {
          const href = `/${segments.slice(0, index + 1).join("/")}`;
          const label = segment
            .split("-")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");

          // Logic: Agar current href 'disabledLinks' mein hai YA ye last page hai,
          // toh Link mat banao, sirf text dikhao.
          const isClickable =
            !disabledLinks.includes(href) && index !== segments.length - 1;

          return (
            <li key={href} className="flex items-center gap-0.5 md:gap-1.5">
              <span className={`span-text ${transparent ? "text-white/50" : "text-gray-400"}`}>
                <ChevronRight size={16} className="link-text" />
              </span>
              {isClickable ? (
                // Agar clickable hai, toh Link dikhao
                <Link
                  href={href}
                  className={transparent ? "text-white/90 hover:text-white" : ""}
                >
                  {label}
                </Link>
              ) : (
                // Agar clickable nahi hai (disabled ya last page), toh sirf text dikhao
                <span
                  className={
                    transparent
                      ? index === segments.length - 1
                        ? "text-white/60 span-text"
                        : "text-white/90 span-text"
                      : index === segments.length - 1
                        ? "text-gray-400 span-text"
                        : "text-primary span-text"
                  }
                >
                  {label}
                </span>
              )}
            </li>
          );
        })}
      </>
    );
  };

  return (
    <nav
      aria-label="Breadcrumb"
      className={`font-medium ta-desktop-home-container ${transparent ? "bg-transparent text-white" : "bg-white text-primary"
        }`}
    >
      <ol className={`flex items-center gap-0.5 md:gap-2 py-2 list-none link-text overflow-x-auto scrollbar-hide whitespace-nowrap ${transparent ? "" : "border-b border-black/10"}`}>
        {renderItems()}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
